import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/informedConsentTindakanService";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "informed-consent-tindakan"
})
class InformedConsentTindakanModule extends VuexModule {
  loading = false;
  items: any[] = [];

  @Mutation
  SET_ITEMS(val: any[]) {
    this.items = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.items = [];
    this.loading = false;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_ITEMS(response.data?.data || []);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(InformedConsentTindakanModule);
